import { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Banner_otherpages from '../../__public/__sections/_Banner_otherpages';
import image from '../../../assets/images/otherpages/faq.jpg';
import Header from '../../__public/__layouts/Header';
import Map from '../../__public/__sections/_Map';
import ceo from "../../../assets/images/ceo2.jpeg"
import ceo2 from "../../../assets/images/ceo4.jpg"


const PressRelease = (props) => {
    useEffect(() => {
        document.title = `${props.company} — Press Release`;
    }, []);

    return (
    <>  
    <Helmet>
      <script src="/js/bootstrap.min.js"></script>
    </Helmet>
    
    <Header />
    <Banner_otherpages title="Press Release" image={image} />
    
    <div className="sections c2_1 c1-sm c1-xs faq" id="pressrelease">
        <div>
            <h2 style={{ lineHeight: '120%' }}>CEO Recognized Among Top 100 Most Innovative CEOs of 2025</h2>

            <div className="award-announcement" style={{ 
                backgroundColor: '#f8f9fa', 
                padding: '2rem', 
                borderRadius: '8px', 
                marginBottom: '2rem',
                border: '1px solid #e9ecef'
            }}>
                {/* <h3 style={{ color: '#28a745', marginBottom: '1.5rem' }}>
                    🎉 Hurray Smash Technology Team! 🎉
                </h3> */}
                
                <div className="award-images" style={{ 
                    display: 'grid', 
                    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', 
                    gap: '1.5rem', 
                    marginBottom: '1.5rem' 
                }}>
                    <img 
                        src={ceo2}
                        alt="Guardian Nigeria Award Certificate"
                        style={{ 
                            width: '100%', 
                            height: 'auto', 
                            borderRadius: '6px',
                            boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
                        }}
                    />
                    <img 
                        src={ceo} 
                        alt="CEO Award Presentation"
                        style={{ 
                            width: '100%', 
                            height: 'auto', 
                            borderRadius: '6px',
                            boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
                        }}
                    />
                </div>

                <p style={{ fontSize: '1.1rem', lineHeight: '1.8' }}>
                    We're proud to share that our CEO, <strong>Amb. Paul Smith</strong>, has been recognized by 
                    <strong> The Guardian Nigeria</strong> as one of the <strong>Top 100 Most Innovative CEOs of 2025</strong>.
                </p>
                
                <p style={{ fontSize: '1.1rem', lineHeight: '1.8' }}>
                    This recognition highlights years of disciplined leadership and impactful innovation 
                    that have positioned Smash Technology as a leader in the technology ecosystem.
                </p>

                <p style={{ 
                    fontSize: '1.2rem', 
                    fontWeight: '600', 
                    color: '#28a745',
                    marginTop: '1.5rem'
                }}>
                    Congratulations to our CEO and the entire Smash Technology team! 
                    <span style={{ marginLeft: '0.5rem' }}>💃🎉</span>
                </p>
            </div>

          
        </div>

        <div className="pie-div">
            <div className="pie"></div>
            <div className="pie"></div>
            <div className="pie"></div>
            <div className="pie"></div>
            <div className="pie"></div>
            <div className="pie"></div>
        </div>
    </div>

    <Map />
    </>
  )
}
export default PressRelease;